import { Checkin, CheckinTeam } from '@vote4dance/judging-schema';
import { CompetitionId } from '@vote4dance/judging-types';
import { StreamSource } from "../hooks/streams";

export type CheckinTeamItem = CheckinTeam & {
    checkin_result: string,
}

export type CheckinItem = Checkin & {
    team_count: string,
}

export function CheckinSource(competition_id: CompetitionId) {
    return new StreamSource<CheckinItem[]>(`/checkins/${competition_id}`);
}

export function CheckinResultSource(competition_id: CompetitionId) {
    return new StreamSource<CheckinTeamItem[]>(`/checkin-results/${competition_id}`);
}

export function CheckinTeamSource(competition_id: CompetitionId, organization_name: string) {
    return new StreamSource<CheckinTeamItem[]>(`/checkin-teams/${competition_id}/${encodeURIComponent(organization_name)}`);
}
